import axios from 'axios'

export default {
  async addGuestWriter (params) {
    // await this.sleep(1500)
    return await axios.post('/api/spa/v1/guest-writer', params)
  },
  async getGuestWriters (params) {
    return await axios.get('/api/spa/v1/guest-writer', { params })
  },
  async getGuestWritersArticle (params) {
    return await axios.get('api/spa/v1/guest-writer/' + params.id + '/articles', { params })
  },
  async getGuestWriterById (id) {
    return await axios.get('/api/spa/v1/guest-writer/' + id)
  },
  async updateGuestWriter (params) {
    return await axios.put('/api/spa/v1/guest-writer/' + params.id, params)
  },
  async deleteGuestWriter (id) {
    return await axios.delete('/api/spa/v1/guest-writer/' + id)
  },
  async sleep (ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }
}
